import { render } from "./CoverImage.vue?vue&type=template&id=303f0328&scoped=true"
import script from "./CoverImage.vue?vue&type=script&lang=js"
export * from "./CoverImage.vue?vue&type=script&lang=js"

import "./CoverImage.vue?vue&type=style&index=0&id=303f0328&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303f0328"]])

export default __exports__